(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carbon-application-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carbon-winch-tabs')) {
    customElements.define('carbon-winch-tabs', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.events?.abort();
        this.gesture = null;
      }

      setup() {
        this.events?.abort();
        this.events = new AbortController();
        const { signal } = this.events;
        this.tabs = Array.from(this.querySelectorAll('.cwt-tab'));
        this.panels = Array.from(this.querySelectorAll('.cwt-panel'));
        const tablist = this.tablist = this.querySelector('.cwt-tabs');
        if (!tablist || this.tabs.length < 2 || this.tabs.length !== this.panels.length) return;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.gesture = null;
        this.suppressClickUntil = 0;

        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
          panel.tabIndex = 0;
        });
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index), { signal });
          tab.addEventListener('keydown', (event) => {
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            let next = index;
            if (event.key === 'ArrowRight') next += direction;
            else if (event.key === 'ArrowLeft') next -= direction;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.activate(next);
            this.tabs[next].focus();
          }, { signal });
        });

        // Selecting a block in Shopify's editor reveals its application.
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex((panel) => panel.dataset.blockId === String(event.detail?.blockId));
          if (index >= 0) this.activate(index);
        }, { signal });

        const panelContainer = this.querySelector('.cwt-panels');
        panelContainer.classList.add('cwt-panels--enhanced');
        this.bindSwipe(panelContainer, signal);
        const navigation = this.querySelector('.cwt-mobile-nav');
        if (navigation) {
          navigation.hidden = false;
          navigation.querySelectorAll('[data-step]').forEach((button) => {
            button.addEventListener('click', () => this.step(Number(button.dataset.step)), { signal });
          });
        }
        window.addEventListener('resize', () => {
          this.gesture = null;
          this.revealActiveTab();
        }, { signal });
        this.classList.add('cwt-ready');
        tablist.hidden = false;
        this.activate(Math.min(this.activeIndex || 0, this.tabs.length - 1), false);
      }

      bindSwipe(container, signal) {
        container.addEventListener('pointerdown', (event) => {
          // A second finger cancels the gesture so pinch zoom remains native.
          if (!event.isPrimary) {
            this.gesture = null;
            return;
          }
          if (!this.mobileQuery.matches || !['touch', 'pen'].includes(event.pointerType)) return;
          this.suppressClickUntil = 0;
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false };
        }, { signal, passive: true });

        container.addEventListener('pointermove', (event) => {
          const gesture = this.gesture;
          if (!gesture || gesture.id !== event.pointerId) return;
          const x = Math.abs(event.clientX - gesture.x);
          const y = Math.abs(event.clientY - gesture.y);
          // Once vertical scrolling starts, this contact cannot change tabs.
          if (!gesture.horizontal && y > 12 && y >= x) this.gesture = null;
          else if (x > 16 && x > y * 1.4) gesture.horizontal = true;
        }, { signal, passive: true });

        container.addEventListener('pointerup', (event) => {
          const gesture = this.gesture;
          this.gesture = null;
          if (!gesture || gesture.id !== event.pointerId || !this.mobileQuery.matches) return;
          const x = event.clientX - gesture.x;
          const y = event.clientY - gesture.y;
          const threshold = Math.max(44, Math.min(72, container.clientWidth * 0.16));
          // Ignore taps, short drags and diagonal/vertical page gestures.
          if (Math.abs(x) < threshold || Math.abs(x) < Math.abs(y) * 1.4) return;
          this.suppressClickUntil = performance.now() + 500;
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          this.step((x < 0 ? 1 : -1) * direction);
        }, { signal, passive: true });

        container.addEventListener('pointercancel', () => { this.gesture = null; }, { signal, passive: true });
        container.addEventListener('click', (event) => {
          // A swipe beginning on a product or photograph must not open its link.
          if (event.detail !== 0 && performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { signal, capture: true });
      }

      step(direction) {
        this.activate((this.activeIndex + direction + this.tabs.length) % this.tabs.length);
      }

      revealActiveTab() {
        if (!this.mobileQuery?.matches) return;
        const tab = this.tabs[this.activeIndex];
        if (!tab) return;
        const strip = this.tablist.getBoundingClientRect();
        const selected = tab.getBoundingClientRect();
        const delta = selected.left < strip.left ? selected.left - strip.left : Math.max(0, selected.right - strip.right);
        // Scroll only the tab strip, leaving the page's vertical position alone.
        if (delta) this.tablist.scrollBy({ left: delta, behavior: 'auto' });
      }

      activate(index, announce = true) {
        this.activeIndex = index;
        this.tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[position].toggleAttribute('data-inactive', !active);
          this.panels[position].inert = !active;
          this.panels[position].setAttribute('aria-hidden', String(!active));
        });
        const position = this.querySelector('.cwt-position');
        if (position) position.textContent = `${index + 1} / ${this.tabs.length}`;
        const status = this.querySelector('.cwt-status');
        if (status && announce) {
          const title = this.tabs[index].querySelector('.cwt-tab-label').textContent.trim();
          status.textContent = `${title}. Application ${index + 1} of ${this.tabs.length}.`;
        }
        this.revealActiveTab();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carbon-free-kit-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carbon-kit-offer')) {
    customElements.define('carbon-kit-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.button = this.querySelector('[data-kit-submit]');
        this.buttonContent = this.querySelector('[data-kit-button-content]');
        this.busyContent = this.querySelector('[data-kit-busy]');
        this.errorMessage = this.querySelector('[data-kit-error]');
        this.successMessage = this.querySelector('[data-kit-success]');
        this.variantSelect = this.querySelector('[data-kit-variant]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.form.addEventListener('submit', event => this.addKit(event), options);
        this.variantSelect?.addEventListener('change', () => this.changeVariant(), options);
        if (document.querySelector('cart-drawer')) this.button.setAttribute('aria-haspopup', 'dialog');
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      changeVariant() {
        const option = this.variantSelect?.selectedOptions[0];
        if (!option) return;
        this.errorMessage.hidden = true;
        this.successMessage.hidden = true;
        const value = this.querySelector('[data-kit-value]');
        if (value && this.dataset.fixedValue !== 'true') value.textContent = option.dataset.price;
        const image = this.querySelector('img.carbon-kit__image');
        if (image && this.dataset.customImage !== 'true' && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
        }
      }

      setBusy(busy) {
        this.pending = busy;
        this.button.disabled = busy;
        this.button.setAttribute('aria-busy', String(busy));
        this.button.setAttribute('aria-label', busy ? this.dataset.addingLabel : this.dataset.buttonLabel);
        this.buttonContent.hidden = busy;
        this.busyContent.hidden = !busy;
        if (this.variantSelect) this.variantSelect.disabled = busy;
      }

      announceCart(data, variantId) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'carbon-kit-offer', productVariantId: variantId, cartData: data });
          } catch (error) {
            // A third-party cart subscriber must not turn a successful add into an error.
          }
        }
      }

      async addKit(event) {
        event.preventDefault();
        if (this.pending || this.button.disabled) return;
        const formData = new FormData(this.form);
        formData.delete('return_to');
        const variantId = formData.get('id');
        if (!variantId) return;
        this.errorMessage.hidden = true;
        this.successMessage.hidden = true;
        let cart = document.querySelector('cart-drawer');
        let sections = [];
        try {
          if (typeof cart?.getSectionsToRender === 'function' && typeof cart?.renderContents === 'function') {
            sections = cart.getSectionsToRender();
            const ids = [...new Set(sections.map(section => section.section).filter(Boolean))].slice(0, 5);
            if (ids.length) {
              formData.set('sections', ids.join(','));
              formData.set('sections_url', window.location.pathname);
              cart.setActiveElement?.(this.button);
            } else cart = null;
          } else cart = null;
        } catch (error) { cart = null; }
        this.setBusy(true);
        let added = false;
        try {
          const endpoint = new URL(this.form.action, window.location.origin);
          endpoint.pathname = endpoint.pathname.replace(/\.js$/, '') + '.js';
          const response = await fetch(endpoint.href, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          let data;
          try {
            data = await response.json();
          } catch (error) {
            throw new Error('We couldn’t confirm the result. Check your cart before trying again.');
          }
          if (!response.ok || data.status) {
            throw new Error(typeof data.description === 'string' ? data.description : this.dataset.errorMessage);
          }
          added = true;
          this.querySelector('[data-kit-success-text]').textContent = this.dataset.successMessage;
          this.successMessage.hidden = false;
          this.announceCart(data, variantId);
          if (cart && sections.every(section => typeof data.sections?.[section.section] === 'string')) {
            try {
              cart.renderContents(data);
              cart.classList.remove('is-empty');
              // Throne opens its drawer after rendering; focus once it becomes visible.
              const observer = new MutationObserver(() => {
                const visible = cart.hasAttribute('cart-drawer-section')
                  ? cart.classList.contains('show')
                  : cart.classList.contains('active');
                if (!visible) return;
                const close = cart.querySelector('[data-drawer-close]');
                if (close && cart.getBoundingClientRect().width > 0) {
                  close.focus({ preventScroll: true });
                  observer.disconnect();
                }
              });
              observer.observe(cart, { attributes: true, attributeFilter: ['class', 'style'] });
              setTimeout(() => observer.disconnect(), 2500);
            } catch (error) {
              // The item was added. Load the cart instead of repeating the request.
              window.location.assign(this.dataset.cartUrl);
            }
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (error) {
          if (!added) {
            this.errorMessage.textContent = error instanceof TypeError
              ? 'The connection was interrupted. Check your cart before trying again.'
              : (error.message || this.dataset.errorMessage);
            this.errorMessage.hidden = false;
          }
        } finally {
          this.setBusy(false);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carbon-promo-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carbon-promo-slider')) {
    customElements.define('carbon-promo-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-promo-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.querySelectorAll('[data-promo-slide]'));
        this.controls = this.querySelector('[data-promo-controls]');
        this.previous = this.querySelector('[data-promo-prev]');
        this.next = this.querySelector('[data-promo-next]');
        this.status = this.querySelector('[data-promo-status]');
        this.current = 0;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.onModeChange = () => this.syncLayout();
        this.mobile.addEventListener('change', this.onModeChange);
        this.track.addEventListener('scroll', () => this.queueUpdate(), { ...options, passive: true });
        this.previous?.addEventListener('click', () => this.goTo(this.current - this.visibleCount()), options);
        this.next?.addEventListener('click', () => this.goTo(this.current + this.visibleCount()), options);
        this.track.addEventListener('keydown', event => {
          if (!this.isSlider() || event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let target;
          if (event.key === 'ArrowRight') target = this.current + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') target = this.current + (rtl ? 1 : -1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.slides.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.goTo(target);
        }, options);
        this.track.addEventListener('focusin', event => {
          if (!this.isSlider()) return;
          const slide = event.target.closest('[data-promo-slide]');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.reveal(index);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.isSlider() || !this.contains(event.target)) return;
          const index = this.slides.findIndex(slide => slide.dataset.promoBlockId === event.detail?.blockId || slide === event.target || slide.contains(event.target));
          if (index >= 0) this.reveal(index);
        }, options);
        this.observer = new ResizeObserver(() => this.syncLayout());
        this.observer.observe(this.track);
        this.setAttribute('data-slider-ready', '');
        this.syncLayout();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.mobile?.removeEventListener('change', this.onModeChange);
        cancelAnimationFrame(this.frame);
      }

      visibleCount() {
        return Math.max(1, parseInt(getComputedStyle(this).getPropertyValue('--carbon-promo-per-view'), 10) || 1);
      }

      maxIndex() {
        return Math.max(0, this.slides.length - this.visibleCount());
      }

      isSlider() {
        const layout = this.mobile.matches ? this.dataset.mobileLayout : this.dataset.desktopLayout;
        return layout === 'slider' && this.maxIndex() > 0;
      }

      reveal(index) {
        if (index < this.current) this.goTo(index, false);
        else if (index >= this.current + this.visibleCount()) this.goTo(index - this.visibleCount() + 1, false);
      }

      syncLayout() {
        this.trackWidth = this.track.clientWidth;
        const active = this.isSlider();
        if (this.controls) this.controls.hidden = !active;
        if (active) {
          this.track.setAttribute('tabindex', '0');
          this.setAttribute('role', 'region');
          this.setAttribute('aria-roledescription', 'carousel');
          this.setAttribute('aria-label', this.track.getAttribute('aria-label'));
          this.goTo(this.current, false);
          this.update();
        } else {
          this.track.removeAttribute('tabindex');
          this.removeAttribute('role');
          this.removeAttribute('aria-roledescription');
          this.removeAttribute('aria-label');
          this.track.scrollLeft = 0;
          this.current = 0;
        }
      }

      queueUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        if (!this.isSlider() || this.trackWidth !== this.track.clientWidth) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const edge = rtl ? 'right' : 'left';
        const origin = this.track.getBoundingClientRect()[edge];
        let nearest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          if (index > this.maxIndex()) return;
          const delta = Math.abs(slide.getBoundingClientRect()[edge] - origin);
          if (delta < distance) { nearest = index; distance = delta; }
        });
        this.current = nearest;
        if (this.previous) this.previous.disabled = nearest === 0;
        if (this.next) this.next.disabled = nearest >= this.maxIndex();
        const count = this.visibleCount();
        const label = count === 1
          ? `Offer ${nearest + 1} of ${this.slides.length}`
          : `Offers ${nearest + 1}–${Math.min(nearest + count, this.slides.length)} of ${this.slides.length}`;
        if (this.status && this.status.textContent !== label) this.status.textContent = label;
      }

      goTo(index, animate = true) {
        if (!this.isSlider()) return;
        const target = Math.max(0, Math.min(index, this.maxIndex()));
        const edge = getComputedStyle(this.track).direction === 'rtl' ? 'right' : 'left';
        const delta = this.slides[target].getBoundingClientRect()[edge] - this.track.getBoundingClientRect()[edge];
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: animate && !reduced ? 'smooth' : 'auto' });
        if (!animate || reduced) this.current = target;
        this.queueUpdate();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
     
class FilpClock extends HTMLElement {
  constructor() {
    super();
    this.targetDate = new Date(this.getAttribute('data-countdown-input')).getTime();
    this.flipclock = this.querySelectorAll('[data-flip-clock]');
    this.timer_labels = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    var time = this.timeDifference(currentDate, this.targetDate);
    if (this.remainingTime <= 0) {

       const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
    }
    
   
   
    if ('IntersectionObserver' in window === false) return;
    const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initializeClock();
          observer.unobserve(this);
        }
    });
    }, { rootMargin: '0px 0px 700px 0px' });
    observer.observe(this);


    this.flipclock.forEach((flipClock) => { 
  var daysFirst = flipClock.querySelector('[data-days-first]');
  var hoursFirst = flipClock.querySelector('[data-hours-first]');
  var minutesFirst = flipClock.querySelector('[data-minutes-first]');
  var secondsFirst = flipClock.querySelector('[data-seconds-first]');


  if (daysFirst) {
    daysFirst.querySelector('[data-day]').value = time.days;
    daysFirst.querySelectorAll('[data-day-top]').forEach((element) => {
      element.textContent = time.days; 
    });
    daysFirst.querySelectorAll('[data-day-bottom]').forEach((element) => {
      element.textContent = time.days; 
    });
  }

  if (hoursFirst) {
    hoursFirst.querySelector('[data-hour]').value = time.hours;
    hoursFirst.querySelectorAll('[data-hour-top]').forEach((element) => {
      element.textContent = time.hours; 
    });
    hoursFirst.querySelectorAll('[data-hour-bottom]').forEach((element) => {
      element.textContent = time.hours; 
    });
  }

  if (minutesFirst) {
    minutesFirst.querySelector('[data-minute]').value = time.minutes;
    minutesFirst.querySelectorAll('[data-minute-top]').forEach((element) => {
      element.textContent = time.minutes; // Update top text for minutes
    });
    minutesFirst.querySelectorAll('[data-minute-bottom]').forEach((element) => {
      element.textContent = time.minutes; // Update bottom text for minutes
    });
  }

  if (secondsFirst) {
    secondsFirst.querySelector('[data-second]').value = time.seconds;
    secondsFirst.querySelectorAll('[data-second-top]').forEach((element) => {
      element.textContent = time.seconds; // Update top text for seconds
    });
    secondsFirst.querySelectorAll('[data-second-bottom]').forEach((element) => {
      element.textContent = time.seconds; // Update bottom text for seconds
    });
  }

});


  }

  initializeClock() {
  this.flipclock.forEach((flipClock) => { // Changed function to arrow function

    var daysFirst = this.createHandles(flipClock.querySelector('[data-days-first]'));
    var hoursFirst = this.createHandles(flipClock.querySelector('[data-hours-first]'));
    var minutesFirst = this.createHandles(flipClock.querySelector('[data-minutes-first]'));
    var secondsFirst = this.createHandles(flipClock.querySelector('[data-seconds-first]'));

    function updateClock() {
      var time = this.timeDifference(currentDate, this.targetDate); // Ensure 'this' refers to FilpClock instance
    

      this.flipDigit(daysFirst, Math.floor(time.days));

      this.flipDigit(hoursFirst, Math.floor(time.hours ));

      this.flipDigit(minutesFirst, Math.floor(time.minutes));
      this.flipDigit(secondsFirst, Math.floor(time.seconds));
   
      this.querySelector('[data-day]').value = time.days;
      this.querySelector('[data-hour]').value = time.hours;
      this.querySelector('[data-minute]').value = time.minutes;
      this.querySelector('[data-second]').value = time.seconds;
      
      if (time.total <= 0) {
        const mainElement = this.closest('.shopify-section');
      if(this.getAttribute('data-timeout-style') == 'show')
      {
        
        mainElement.querySelector('[data-message]').classList.remove('hidden');
        mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      if(this.getAttribute('data-timeout-style') == 'hide'){
          mainElement.querySelector('filpclock-counter').style.display = 'none';
      }

      return;
      
        clearInterval(timeinterval);
      }
    }
    var currentDate = new Date().getTime(); // Define currentDate here
    var timeinterval = setInterval(updateClock.bind(this), 1000); // Bind updateClock to FilpClock instance
    });
  }


  timeDifference(current, target) {
    const currentDate = new Date().getTime();
    this.remainingTime = this.targetDate - currentDate;
    const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);

    return {
      'total': this.remainingTime,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  createHandles(flipElement) {
    var flipperTop = flipElement.querySelector("[flipper-top]");
    var flipperBottom = flipElement.querySelector("[flipper-bottom]");
    var flipperDisplayTop = flipElement.querySelector("[flip-display-top]");
    var flipperDisplayBottom = flipElement.querySelector("[flip-display-bottom]");
    var flipHiddenInput = flipElement.querySelector("[type='hidden']");
    return {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    };
  }

  flipDigit(flipHandles, digitValue) {
    var {
      flipElement,
      flipperTop,
      flipperBottom,
      flipperDisplayBottom,
      flipperDisplayTop,
      flipHiddenInput,
    } = flipHandles;

    var setPreviousValue = function(value) {
      flipperTop.innerText = value;
      flipperDisplayBottom.innerText = value;
    };
    var setAfterValue = function(value) {
      flipperDisplayTop.innerText = value;
      flipperBottom.innerText = value;
    };

    if (parseInt(flipHiddenInput.value) !== digitValue) {
      setPreviousValue(flipHiddenInput.value);
      flipHiddenInput.value = digitValue;
      var valueChangedEvent = new Event('valueChanged');
      flipHiddenInput.dispatchEvent(valueChangedEvent);
    }

    flipHiddenInput.addEventListener('valueChanged', function() {
      setAfterValue(flipHiddenInput.value);
      flipElement.classList.add("play");
    });

    flipperBottom.addEventListener('animationend', function() {
      setAfterValue(flipHiddenInput.value);
      setPreviousValue(flipHiddenInput.value);
      flipElement.classList.remove("play");
    });
  }
}
customElements.define('filpclock-counter', FilpClock);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
     
class FeatureProducts extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    const currentSection = this.closest('.shopify-section');
    const offsetSection = currentSection.getBoundingClientRect();

    if (offsetSection.top < window.innerHeight && offsetSection.bottom > 70) {
      this.classList.add('is-active');
    }
  }
}

customElements.define('feature-products', FeatureProducts);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-accordion]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          // Show accordion on mobile if setting allows
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open',true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
          const getContent = el.querySelector('[data-collapsible-content]');
          if(getContent){
            getContent.style.opacity = '1';
          }
        }
      });
    };
    applyAccordionState();
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    mobileQuery.addEventListener('change', () => {
      applyAccordionState();
    });
    // window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Sizechart extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[data-size-chart]').addEventListener('click', this.init.bind(this));
    }

    init(e) {
      e.preventDefault();
      const popupModal = this.querySelector('popup-modal');
      popupModal.modalPopupOpen('data-size-chart-popup');
    }
  }
  customElements.define('size-chart', Sizechart);

  class ProgressBar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.style.setProperty(
        '--progress_width',
        `${(parseInt(this.dataset.value) * 0.75 * 100) / parseInt(this.dataset.max)}%`
      );
    }
  }
  customElements.define('progress-bar', ProgressBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-bar"] && !Shopify.designMode) return;
  try {
    
  class PromotionalBar extends HTMLElement {
    constructor() {
      super();

      const popupModal = this.querySelector('popup-modal');

      this.videos = this.querySelectorAll('[promotional-bar-video]');

      this.videos.forEach((video) => {
        video.addEventListener('click', () => {
          const videoId = video.getAttribute('data-id');
          console.log(videoId);
          popupModal.modalPopupOpen(`data-video-popup-${videoId}`);
        });
      });
    }
  }

  customElements.define('promotional-bar', PromotionalBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-blog-articles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carbon-blog-browser')) {
    customElements.define('carbon-blog-browser', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.updateFrame);
        this.events?.abort();
        this.resizeObserver?.disconnect();
      }

      setup() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.track = this.querySelector('[data-track]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.navigation = this.querySelector('[data-navigation]');
        this.status = this.querySelector('[data-status]');
        if (!this.track || !this.cards.length || !this.previous || !this.next) return;

        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * direction);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({
              left: event.key === 'Home' ? 0 : direction * this.track.scrollWidth,
              behavior: this.scrollBehavior()
            });
          }
        }, options);

        window.addEventListener('resize', () => this.scheduleUpdate(), options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
          this.resizeObserver.observe(this.track);
        }
        this.update();
      }

      scrollBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 24;
        const step = this.cards[0].getBoundingClientRect().width + gap;
        const sign = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * step * sign, behavior: this.scrollBehavior() });
      }

      scheduleUpdate() {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.update());
      }

      update() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.abs(this.track.scrollLeft);
        this.navigation.hidden = maximum <= 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;

        const viewport = this.track.getBoundingClientRect();
        const visible = this.cards.reduce((indices, card, index) => {
          const bounds = card.getBoundingClientRect();
          const overlap = Math.min(bounds.right, viewport.right) - Math.max(bounds.left, viewport.left);
          if (overlap >= Math.min(bounds.width, viewport.width) * 0.5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length || !this.status) return;
        const offset = Number(this.track.dataset.offset) || 0;
        const start = offset + visible[0] + 1;
        const end = offset + visible[visible.length - 1] + 1;
        const range = start === end ? String(start) : `${start}\u2013${end}`;
        const text = `Articles ${range} of ${this.track.dataset.total}`;
        if (this.status.textContent.trim() !== text) this.status.textContent = text;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icon"] && !Shopify.designMode) return;
  try {
     
class Textwithicon extends HTMLElement{
  constructor() {
    super();
    const resizeObserver = new ResizeObserver(this.getHeight.bind(this));
    resizeObserver.observe(this);
    //this.getHeight();
  }
  getHeight(){
    this.divElement = this.querySelectorAll("[data-text-icon-desc]");
    this.divElement.forEach(element => {
      this.elemHeight = element.getBoundingClientRect().height;
      let closestParent = element.closest('[data-text-icon-inner]');
      if (closestParent) {
    
        closestParent.style.setProperty('--description_height', `${this.elemHeight}px`);
      }
    });
  }
}
customElements.define('text-with-icon', Textwithicon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
     
class AnimatedCursor extends HTMLElement {
  constructor() {
    super();

    this.mouse = { x: -100, y: -100 };
    this.pos = { x: 0, y: 0 };
    this.speed = 0.15;
    this.element = null; // Keep track of the current element with cursor class

    
    //window.addEventListener('mousedown', this.startDrag.bind(this));
   // window.addEventListener('mouseup', this.endDrag.bind(this));

    const cursorPointer = this.closest('.section-video');

    if(! cursorPointer){ 
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));  
        return; 
      }
    // window.addEventListener('mousedown', this.startDrag.bind(this));
    cursorPointer.querySelectorAll('[cursor-class]').forEach((cursorModifier) => {
     cursorModifier.addEventListener('pointermove', this.updateCoordinates.bind(this));
      cursorModifier.addEventListener('mouseenter', this.addCursorClass.bind(this));
      cursorModifier.addEventListener('mouseleave', this.removeCursorClass.bind(this));
      cursorModifier.addEventListener('mouseout', this.removeCursor.bind(this));
      cursorModifier.addEventListener('scroll', () => {
        console.log('Scroll event fired');
      });
      cursorModifier.addEventListener('pointermove', this.removeCursor.bind(this));
      cursorModifier.addEventListener('mouseup', this.endDrag.bind(this));
      cursorModifier.addEventListener('mousedown', this.startDrag.bind(this)); // Add mousedown event here
    });

    requestAnimationFrame(this.loop.bind(this));
  }

  startDrag(e) {
    this.updateCoordinates(e);
  }

  endDrag(e) {
    this.updateCoordinates(e);
  }

  removeCursor(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    this.elementName = event.target.tagName;
  }

  handleScroll(e){
    console.log("wqewqe");
  }
  updateCoordinates(e) {
    this.mouse.x = e.clientX;
    this.mouse.y = e.clientY;
  }

  getAngle(diffX, diffY) {
    return (Math.atan2(diffY, diffX) * 180) / Math.PI;
  }

  getSqueeze(diffX, diffY) {
    const distance = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
    const maxSqueeze = 0.0;
    const accelerator = 1500;
    return Math.min(distance / accelerator, maxSqueeze);
  }

  updateCursor() {
    const diffX = Math.round(this.mouse.x - this.pos.x);
    const diffY = Math.round(this.mouse.y - this.pos.y);

    this.pos.x += diffX * this.speed;
    this.pos.y += diffY * this.speed;

    const angle = this.getAngle(diffX, diffY);
    const squeeze = this.getSqueeze(diffX, diffY);

    // Update cursor style with transformations
    this.style.translate = `${this.pos.x}px ${this.pos.y}px`;
    //this.style.transform = `scale(${2 + squeeze}, ${2 - squeeze}) rotate(${angle}deg) translate3d(${this.pos.x}px, ${this.pos.y}px, 0)`;
  }

  loop() {
    this.updateCursor();
    requestAnimationFrame(this.loop.bind(this));
  }

  addCursorClass(event) {
    this.element = event.currentTarget;
    const className = this.element.getAttribute('cursor-class');
    if (className === 'video') {
      this.classList.add('king_cursor');
      this.videoButton = this.element.querySelector('[data-content-button]');
     
      if(this.videoButton){
      this.videoButton.style.display = "none";
      }
      this.innerHTML = this.videoButton.innerHTML;
    }
  }

  removeCursorClass(event) {
    const element = event.currentTarget;
    console.log(element);
    const className = element.getAttribute('cursor-class');
    if (className === 'video') {
      this.videoButton = this.element.querySelector('[data-content-button]');
      if(this.videoButton){
      this.videoButton.style.display = "block";
      }
      this.innerHTML = '';
      this.classList.remove('king_cursor');
    }
  }
}

customElements.define('animated-cursor', AnimatedCursor);


  } catch(e) { console.error(e); }
})();
})();
